import type { StoreLocation } from '../../../components/loyalty/data/types';

export const SET_LOCATIONS = 'loyalty/locations/SET_LOCATIONS';

export const setLocations = (locations: StoreLocation[]) => ({
  type: SET_LOCATIONS as typeof SET_LOCATIONS,
  payload: locations,
});

export type LoyaltyLocationsAction = ReturnType<typeof setLocations>;
